export const TOGGLE_PLAYER_MODE = "TOGGLE_PLAYER_MODE";
